import ChartContainer from '@/views/storyboard/charts/ChartContainer';
import BaseCellHandler, {BaseCellHandlerProps} from './BaseCellHandler';
import {EchartsChartType} from '@/views/storyboard/utils/chartConstants';
import {BarOrientation, BarSortOrder, DataLabelPosition} from 'entities/chart';


class ChartCellHandler extends BaseCellHandler {
    constructor(props: BaseCellHandlerProps) {
        super(props);
        
        // Set endpointUrl in constructor to ensure it gets the loaded URL configuration
        // Add trailing slash to match Flask route definition
        this.endpointUrl = window.URLS.performSearchQuery;
        
    }


    renderContent() {
        const {
            chartId,
            chartType,
            chartHeight,
            chartWidth,
            chartTitle,
            chartDescription = '',
            chartRef,
            linearRegression,
            comparablePeriod,
            movingAverageDays,
            movingAverageDaysCenter,
            scalingFactor,
            barOrientation = BarOrientation.Vertical,
            barSortOrder = BarSortOrder.HighToLow,
            dataLabelPosition = DataLabelPosition.Off,
            chartQuery,
            previewOnly,
            chartSettingsView,
            onPreviewFooterChange,
        } = this.props;
        const {data, queryDuration} = this.state;

        return (
            <ChartContainer
                type={chartType as unknown as EchartsChartType}
                height={chartHeight}
                width={chartWidth}
                title={chartTitle}
                description={chartDescription}
                linearRegression={linearRegression}
                comparablePeriod={comparablePeriod}
                movingAverageDays={movingAverageDays}
                movingAverageDaysCenter={movingAverageDaysCenter}
                scalingFactor={scalingFactor}
                barOrientation={barOrientation}
                barSortOrder={barSortOrder}
                dataLabelPosition={dataLabelPosition}
                data={data!}
                chartQuery={chartQuery}
                chartRef={chartRef}
                previewOnly={previewOnly}
                queryDuration={queryDuration}
                chartSettingsView={chartSettingsView}
                chartId={chartId || undefined}
                onPreviewFooterChange={onPreviewFooterChange}
            />
        );
    }
}

export default ChartCellHandler;
